import { SelectApiSource, SystemEntity } from '@wdx/shared/swagger-gen';

export const REFERENCE_SELECT_SOURCES: Record<string, SelectApiSource> = {
    [SystemEntity.KanbanStage]: SelectApiSource.KanbanStages,
};
